export const name = "favoriteModules";
export const constants = { name };